const models = {
  portugues: {
    title: 'Modelos',
    subTitle: 'Conheça as mais belas gatas do Bella da Semana. Confira abaixo as últimas modelos:',
    placeHolderSelect: 'Filtrar por nome',
    SeeAllModels: 'Veja todas modelos:',
    labelPagination: 'de',
    shootModel: 'Veja o ensaio',
    featuredModels: 'Modelos em destaque:',
    lastModels: 'Últimas Modelos',
    mostViewed: 'Mais Acessadas',
    models: 'Modelos',
    seeAllModels: 'CLIQUE E VEJA TODAS AS NOSSAS MODELOS'    
  },
  ingles: {
    title: 'Models',
    subTitle: 'Meet the most beautiful Bella Club babes. Check out the latest models below:',
    placeHolderSelect: 'Filter by name',
    SeeAllModels: 'See all models:',
    labelPagination: 'of',
    shootModel: 'See the shoot',
    featuredModels: 'Featured Models:',
    lastModels: 'Last Models',
    mostViewed: 'Most Viewed',
    models: 'Models',
    seeAllModels: 'CLICK AND SEE ALL OUR MODELS'        
  }
}

export default models
